import { render, staticRenderFns } from "./QShortReadonly.vue?vue&type=template&id=0df02fa0&scoped=true"
import script from "./QShortReadonly.vue?vue&type=script&lang=js"
export * from "./QShortReadonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df02fa0",
  null
  
)

export default component.exports